import AuthorizedUsersSection from '@/components/AuthorizedUsersSection'

export default function Settings() {
  return (
    <div className="min-h-0 flex-1 overflow-y-auto px-6 py-8">
      <div className="mx-auto w-full max-w-4xl">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-gray-900">Settings</h1>
          <p className="mt-1 text-sm text-gray-600">
            Manage who can access Inquisitor.
          </p>
        </div>
        <AuthorizedUsersSection />
      </div>
    </div>
  )
}
